import apiClient from '@/scripts/api/apiClient';
import axios from 'axios';

// Asset API query key factory
export const assetKeys = {
  getUploadUrl: () => ['get', 'assets', 'uploadUrl'],
  completeUpload: () => ['complete', 'assets', 'upload'],
  getAsset: (assetId) => ['get', 'assets', assetId],
};

/**
 * Get a pre-signed upload URL from the backend
 * @param {Object} data - Upload request data
 * @returns {Promise} - Response with upload URL(s)
 */
export const getUploadUrl = async (data) => {
  const response = await apiClient.post('/api/assets/upload-url', data);
  return response.data;
};

/**
 * Use a raw axios instance for uploads to pre-signed URLs
 * This bypasses apiClient because pre-signed URLs require specific headers
 * and no additional auth tokens
 * 
 * @param {string} url - Pre-signed URL to upload to
 * @param {File} file - File to upload
 * @param {Object} options - Upload options
 * @param {Object} options.headers - Request headers
 * @param {Function} options.onUploadProgress - Progress callback
 * @returns {Promise} - Upload response
 */
export const uploadFile = async (url, file, options = {}) => {
  const { headers = { 'Content-Type': file.type }, onUploadProgress } = options;
  
  const response = await axios.put(url, file, {
    headers,
    onUploadProgress
  });
  
  return response;
};

/**
 * Complete a multipart upload
 * @param {Object} data - Completion data with parts information
 * @returns {Promise} - Response with final file URL
 */
export const completeUpload = async (data) => {
  const response = await apiClient.post('/api/assets/complete-upload', data);
  return response.data;
};
